import { ModalTypes } from 'enums/modalTypes';
import { useSoftSkillRoleLevelContentUploadMutation } from 'generated/graphql';
import { closeModal } from 'graphql/modals';
import { useState } from 'react';
import {
  Button,
  FileUploadInput,
  InlineNotification,
  Modal,
  ModalSize,
  NotificationType,
  TNotification,
  useNotification,
} from '@spotted-zebra-uk/ui-components';
import styles from './UploadSoftSkillsContentCSVModal.module.scss';

const UploadSoftSkillsContentCSVModal = () => {
  const [fileUploadValue, setFileUploadValue] = useState<File | null>(null);
  const [errorMessages, setErrorMessages] = useState<string[]>([]);
  const { handleMsgType } = useNotification();

  const close = () => {
    closeModal(ModalTypes.UPLOAD_SOFT_SKILLS_CONTENT_CSV_MODAL);
  };

  const [fileUpload, fileUploadResponse] =
    useSoftSkillRoleLevelContentUploadMutation({
      context: {
        isUpload: true,
      },
      onError: error => {
        setErrorMessages([error?.message]);
        setFileUploadValue(null);
      },
      onCompleted: () => {
        handleMsgType({
          type: TNotification.success,
          title: 'Soft skills content uploaded successfully.',
        });
        return close();
      },
    });

  const handleChangeFile = (file: File | null, id: string) => {
    errorMessages.length && setErrorMessages([]);
    setFileUploadValue(file);
  };

  const handleSubmit = () => {
    if (fileUploadValue) {
      fileUpload({ variables: { file: fileUploadValue } });
    }
  };

  return (
    <Modal
      onClose={close}
      isOpen
      modalSize={ModalSize.SMALL}
      className={styles.container}
      header="Upload soft skills content"
    >
      <div className={styles.content}>
        <FileUploadInput
          id="csvFile"
          placeholder="Select file"
          value={fileUploadValue}
          onChange={handleChangeFile}
          acceptedFileTypes={['.csv']}
          className={styles.inputField}
        />
        {Boolean(errorMessages.length) && (
          <InlineNotification
            notificationType={NotificationType.ERROR}
            className={styles.errorNotification}
            children={errorMessages.map((error, index) => (
              <p className={styles.errorItem} key={error}>
                {`${index + 1}. ${error}`}
              </p>
            ))}
          />
        )}
        <div className={styles.buttonContainer}>
          <Button size="medium" onClick={close} variant="secondary">
            Cancel
          </Button>
          <Button
            disabled={!fileUploadValue || fileUploadResponse.loading}
            size="medium"
            onClick={handleSubmit}
          >
            {fileUploadResponse.loading ? 'Validating...' : 'Upload CSV'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default UploadSoftSkillsContentCSVModal;
